const quizQuestions = [...document.querySelectorAll('.j-question')];

quizQuestions.forEach((question, index) => {
    const input = question.querySelector('textarea');

    if (input.dataset.validateRequired) {
        const error = question.querySelector(`[data-validate-error]`);

        input.dataset.validateName = `quiz__questions-error-${index}`;
        error.dataset.validateError = input.dataset.validateName;
        error.classList.add('input__error-text_quiz');
    }
});
